
import VueHorizontal from "vue-horizontal";
export default {
  components: { VueHorizontal },
  data() {
    return {
      activeTooltip: null,
      tooltipText: "",
      plans: ["monthly", "annually"],
      selectedCategory: 0,
      scroll: false,
      selectedPlan: "monthly",
      categoryProducts: [],
      onDemandProducts: [],
      sortedCategories: [],
      loading: true,
      left: 0,
      originX: 0,
      originLeft: 0,
      leftCategories: 0,
      originXCategories: 0,
      originLeftCategories: 0,
      options: [
        {
          name: "title",
          label: "Naslov",
          type: "text",
        },
        {
          name: "tooltip",
          label: "Tooltip text",
          type: "textarea",
        },
        {
          name: "name",
          label: "Ime (nece biti vidljivo - sva se moraju razlikovat)*",
          type: "text",
        },
      ],
      optionsOnDemand: [
        {
          name: "title",
          label: "Naslov",
          type: "text",
        },
      ],
      optionsTest: [
        {
          name: "title",
          label: "Naslov",
          type: "text",
        },
        {
          name: "tooltip",
          label: "Tooltip text",
          type: "textarea",
        },
        {
          name: "name",
          label: "Ime (nece biti vidljivo - sva se moraju razlikovat)*",
          type: "text",
        },
      ],
    };
  },
  watch: {
    selectedCategory() {
      this.checkIfIsOverflown();
    },
  },
  mounted() {
    setTimeout(() => {
      if (
        this.$refs.categories &&
        this.$refs.categories.categories &&
        this.$refs.categories.categories.length &&
        this.$refs.categories.categories[0].id
      ) {
        this.sortCategories(this.$refs.categories.categories);

        if (this.sortedCategories && this.sortedCategories.length) {
          this.selectedCategory = this.sortedCategories[0].id;
          this.getProductsFromCategory(this.sortedCategories[0].id);
        }
      }
    }, 700);
  },

  methods: {
    checkIfIsOverflown() {
      setTimeout(() => {
        const element = document.getElementsByClassName("element-width");
        const box = document.getElementsByClassName("box-width");
        if (!element || !box) return;

        if (element[0].scrollWidth > box[0].clientWidth) {
          this.scroll = true;
        } else this.scroll = false;
      }, 300);
    },
    sortCategories(categories) {
      this.sortedCategories = categories.sort(
        (a, b) => a.createdAt - b.createdAt
      );
    },
    returnProductByDate(product) {
      if (!product) return false;
      if (!product.tags) {
        return false;
      }

      let obj;
      if (this.selectedPlan === "monthly") {
        obj = product.tags[0].name === "Mjesečno";
      }

      if (this.selectedPlan === "annually") {
        obj = product.tags[0].name === "Godišnje";
      }
      if (obj) {
        return true;
      } else {
        return false;
      }
    },
    async getProductsFromCategory(id) {
      if (!id) return false;
      this.selectedCategory = id;
      this.categoryProducts.splice(0, this.categoryProducts.length);
      const data = {
        filters: [
          {
            key: "categories",
            value: [id],
          },
          {
            key: "archived",
            value: false,
          },
        ],
        select: [
          "name",
          "id",
          "description",
          "basicPrice",
          "retailPrice",
          "media",
          "slug",
          "tags",
          "attributes",
          "customOptions",
          "featured",
          "categories",
        ],
      };
      const dat = await this.$api.product.web.filter(data);
      if (dat && dat.data && dat.data.records && dat.data.records.length) {
        const products = [...dat.data.records];
        this.categoryProducts = this.sortByLowestPrice(products);
        this.loading = false;
        if (this.categoryProducts && this.categoryProducts.length) {
          this.categoryProducts.forEach((product) => {
            if (
              product.tags &&
              product.tags.length &&
              product.tags[0].name === "on_demand"
            ) {
              if (
                this.onDemandProducts.length &&
                product.tags[0].id !== this.onDemandProducts[0].tags[0].id
              ) {
                this.onDemandProducts.push(product);
              } else if (!this.onDemandProducts.length)
                this.onDemandProducts.push(product);
              else return this.onDemandProducts;
            }
          });
        }
      }
    },
    sortByLowestPrice(products) {
      const sortedProducts = products.sort(
        (a, b) => a.retailPrice - b.retailPrice
      );
      if (sortedProducts && sortedProducts.length) {
        return sortedProducts;
      } else return products;
    },
    onScroll({ left }) {
      this.left = left;
    },
    onMouseDown(e) {
      this.originX = e.pageX;
      this.originLeft = this.left;

      window.addEventListener("mouseup", this.onMouseUp);
      window.addEventListener("mousemove", this.onMouseMove);
    },
    onMouseUp() {
      window.removeEventListener("mouseup", this.onMouseUp);
      window.removeEventListener("mousemove", this.onMouseMove);
    },
    onMouseMove(e) {
      const offset = e.pageX - this.originX;
      const left = this.originLeft - offset;

      this.$refs.horizontal.scrollToLeft(left, "auto");
    },

    onScrollCategories({ left }) {
      this.leftCategories = left;
    },
    onMouseDownCategories(e) {
      this.originXCategories = e.pageX;
      this.originLeftCategories = this.leftCategories;

      window.addEventListener("mouseup", this.onMouseUpCategories);
      window.addEventListener("mousemove", this.onMouseMoveCategories);
    },
    onMouseUpCategories() {
      window.removeEventListener("mouseup", this.onMouseUpCategories);
      window.removeEventListener("mousemove", this.onMouseMoveCategories);
    },
    onMouseMoveCategories(e) {
      const offset = e.pageX - this.originXCategories;
      const left = this.originLeftCategories - offset;

      this.$refs.horizontalCategories.scrollToLeft(left, "auto");
    },

    dotToComma(price) {
      let stringPrice = price.toString();
      stringPrice = stringPrice.replace(".", ",");
      if (stringPrice && stringPrice.length) {
        return stringPrice;
      } else return price;
    },
    setActiveTooltip(i) {
      if (this.$refs.feeTooltip) {
        const tooltips = this.$refs.feeTooltip;
        this.tooltipText = tooltips[i].$el.outerText;
      } else return (this.tooltipText = null);
    },

    prev() {
      if (this.$refs.horizontal) {
        this.$refs.horizontal.scrollToLeft(-1000);
      }
    },
    next() {
      if (this.$refs.horizontal) {
        this.$refs.horizontal.scrollToLeft(1000);
      }
    },
  },
};
